import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";

const DecimalComponent = ({
    kriterId,
    kriterAdi,
    parentKriterId,
    parentSecenekId = null,
    selKriterler,
    bagliOlunanKriterId,
    bagliOlunanKriterSecenekId,
    zorunlu = false,
    onChange }) => {

    const [visiable, setVisiable] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (bagliOlunanKriterId) {
            const isVisible =
                bagliOlunanKriterSecenekId &&
                selKriterler &&
                selKriterler[bagliOlunanKriterId]?.value === bagliOlunanKriterSecenekId;
            setVisiable(!!isVisible);
        } else {
            setVisiable(true);
        }
    }, [bagliOlunanKriterId, bagliOlunanKriterSecenekId, selKriterler]);

    if (visiable === false)
        return <></>;

    const handleChange = (event) => {
        let inputValue = event.target.value;

        // Allow only numbers with max one decimal point
        if (/^\d*\.?\d{0,1}$/.test(inputValue) || inputValue === "") {
            onChange(kriterId, inputValue);
        }
    };

    const handleKeyPress = (event) => {
        // Allow only digits and a single dot, block commas and other characters
        if (
            (event.key === "," || event.key === "e" || event.key === "+" || event.key === "-" || event.key === '*' || event.key === '/') || // block comma and other invalid characters
            (event.key === "." && event.target.value.includes(".")) // block more than one dot
        ) {
            event.preventDefault();
        }
    };

    return (
        <Box sx={{ pt: 2 }}>
            <TextField
                key={kriterId}
                label={
                    <span>
                        {kriterAdi}
                        {zorunlu && <span style={{ color: "red", fontSize: "1.3rem", fontWeight: "bold" }}> *</span>}
                    </span>
                }
                variant="outlined"
                margin="dense"
                InputLabelProps={{ shrink: true }}
                type="number"
                defaultValue={selKriterler[kriterId]?.value || ""}
                fullWidth
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                error={hasError}
                helperText={hasError ? 'Lütfen ondalık sayı giriniz ve ondalık ayırıcı olarak nokta (.) kullanınız (xx.xx)' : ''}
                inputProps={{
                    inputMode: "decimal",
                    pattern: "\\d+(\\.\\d{0,1})?",
                    step: "0.1",
                }}
            />
        </Box>
    );
};

export default DecimalComponent;
